import(/* webpackMode: "eager" */ "/codebuild/output/src2411639661/src/upsight-front-developer-for-spring-/src/app/layout.tsx");
